// TODO: We could do this in Ruby instead to reduce vendor JS
import { parseNumber, formatNumber } from 'libphonenumber-js'
import { DateTime } from 'luxon'

DateTime.DATE_TINY = {
  month: 'numeric',
  day: 'numeric',
}

DateTime.DATE_DAYF_MONTH = {
  day: 'numeric',
  weekday: 'long',
  month: 'short',
}

const DateTimeFormats = [
  'DATE_TINY', 'DATE_SHORT', 'DATE_MED', 'DATE_FULL', 'DATE_HUGE',
  'TIME_SIMPLE', 'TIME_WITH_SECONDS', 'TIME_WITH_SHORT_OFFSET', 'TIME_WITH_LONG_OFFSET', 'TIME_24_SIMPLE',
  'TIME_24_WITH_SECONDS', 'TIME_24_WITH_SHORT_OFFSET', 'TIME_24_WITH_LONG_OFFSET',
  'DATETIME_SHORT', 'DATETIME_SHORT_WITH_SECONDS', 'DATETIME_MED', 'DATETIME_MED_WITH_SECONDS', 'DATETIME_FULL',
  'DATETIME_FULL_WITH_SECONDS', 'DATETIME_HUGE', 'DATETIME_HUGE_WITH_SECONDS',
]

const pluralize = require('pluralize')

const currencyFormatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function capitalizeWords(string) {
  return capitalizeEach(string.split(' '))
}

export function capitalizeEach(array) {
  return array.map(word => capitalize(word))
}

const Filters = {
  install(Vue) {
    Vue.filter('phone', phone => formatNumber(parseNumber(phone, 'US'), 'National'))
    Vue.filter('date', (date, format) => {
      if (!date) return ''
      let actualFormat = format
      if (DateTimeFormats.indexOf(format) >= 0) actualFormat = DateTime[format]
      if (date.plus) return date.toLocaleString(actualFormat)
      return DateTime.fromISO(date).toLocaleString(actualFormat)
    })
    Vue.filter('weekdayShort', date => DateTime.fromISO(date).toLocaleString({ weekday: 'short' }))
    Vue.filter('weekdayLong', date => DateTime.fromISO(date).toLocaleString({ weekday: 'long' }))
    Vue.filter('pluralize', (count, word, inclusive) => (word ? pluralize(word, count, inclusive) : null))
    Vue.filter('capitalize', string => capitalize(string))
    Vue.filter('capitalizeEach', array => capitalizeEach(array))
    Vue.filter('join', (array, separator) => array.join(separator))
    Vue.filter('currency', number => currencyFormatter.format(number))
    Vue.filter('cents', number => currencyFormatter.format(number / 100))
  },
}

export default Filters
